import React from 'react';
import { Props } from '../../types';
import { Container } from '../../styles';
import { orange, blue, green, red } from '../../index';

const Status: React.FC<Props> = ({ acronym }) => {
  let text = React.useRef('');
  let color = React.useRef('');

  switch (acronym) {
    case 'AGA':
      color.current = orange;
      text.current = 'Aguardando agendamento';
      break;
    case 'AGE':
      color.current = blue;
      text.current = 'Agendado';
      break;
    case 'EXP':
      color.current = green;
      text.current = 'Expedido';
      break;
    case 'CAN':
      color.current = red;
      text.current = 'Cancelado';
      break;
    default:
      color.current = '#777';
      text.current = 'Sem informações de status';
      break;
  }

  return (
    <Container data-cy="statusAtendimento" color={color.current}>
      {text.current}
    </Container>
  );
};

export default Status;
